import { Outlet, useLocation } from 'react-router-dom';
import { useFavorites } from './hooks/useFavorites.js';
import { useCompare } from './hooks/useCompare.js';
import Header from './components/layout/Header.jsx';
import Footer from './components/layout/Footer.jsx';
import MobileMenu from './components/layout/MobileMenu.jsx';
import MobileBottomNav from './components/layout/MobileBottomNav.jsx';
import Toast from './components/ui/Toast.jsx';
import { useState } from 'react';

export const FavContext  = /** @type {any} */ (/** @type {unknown} */ (null));
export const CmpContext  = /** @type {any} */ (/** @type {unknown} */ (null));
import React from 'react';
export const FavsCtx = React.createContext(null);
export const CmpCtx  = React.createContext(null);
export const ToastCtx = React.createContext(null);

export default function App() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [favs, toggleFav] = useFavorites();
  const [cmp,  toggleCmp, clearCmp] = useCompare();
  const [toast, setToast] = useState(null);

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(null), 2800); };
  const isDetail = location.pathname.startsWith('/propiedad/');
  const hideFt   = location.pathname === '/buscar';

  return (
    <FavsCtx.Provider value={{ favs, toggleFav }}>
    <CmpCtx.Provider value={{ cmp, toggleCmp, clearCmp }}>
    <ToastCtx.Provider value={{ showToast }}>
      <a className="skip-link" href="#main">Saltar al contenido</a>
      <Header onOpenMenu={() => setMenuOpen(true)} favs={favs} cmp={cmp} />
      <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
      <main id="main" className="app-root">{<Outlet />}</main>
      {!hideFt && <Footer />}
      <MobileBottomNav favs={favs} />
      {!isDetail && (
        <a className="wa-float" href={`https://wa.me/${import.meta.env.VITE_WA_VENTAS||'5491163723335'}`}
          target="_blank" rel="noopener" aria-label="WhatsApp">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12 2a10 10 0 0 0-8.5 15.2L2 22l4.9-1.3A10 10 0 1 0 12 2Zm0 1.8a8.2 8.2 0 0 1 6.9 12.6l-.3.5.7 2.6-2.7-.7-.4.2A8.2 8.2 0 1 1 12 3.8Zm-3 3.7c-.2 0-.5 0-.7.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.1 5 4.3 2.4 1 2.9.8 3.4.7.5 0 1.6-.6 1.8-1.3.2-.6.2-1.2.2-1.3l-.6-.3c-.3-.2-1.6-.8-1.8-.9-.3-.1-.4-.1-.6.2l-.8 1c-.1.2-.3.2-.6.1-.3-.2-1.2-.5-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6l.5-.5.3-.5v-.5L9.7 8c-.2-.4-.4-.4-.6-.4Z"/>
          </svg>
        </a>
      )}
      <Toast msg={toast} />
    </ToastCtx.Provider>
    </CmpCtx.Provider>
    </FavsCtx.Provider>
  );
}
